import { Components, ColorProfiles } from '@powdr/constants';

// Color Profiles
const {
  BASE, PRIMARY, SECONDARY, TERTIARY, QUATERNARY,
} = ColorProfiles;

export const config = {
  [Components.HEADER]: PRIMARY,
  [Components.MAIN_NAV]: PRIMARY,
  [Components.MEGA_NAV]: BASE,
  [Components.MOBILE_NAV]: BASE,
  [Components.ECOMMERCE_BANNER]: PRIMARY,
  [Components.WEATHER_FEED]: TERTIARY,
  [Components.PROMOTIONS_FEED]: PRIMARY,
  [Components.PROMOTIONS]: PRIMARY,
  [Components.ALERT_BAR]: PRIMARY,
  [Components.STICKY_NAV]: SECONDARY,
  [Components.TERTIARY_NAV]: BASE,
  [Components.LEVELS_MODAL]: TERTIARY,
  [Components.FOOTER]: SECONDARY,
  [Components.FOOTER_NAV]: SECONDARY,
  [Components.PARTNERS]: QUATERNARY,
  [Components.COPYRIGHT]: PRIMARY,
  [Components.MODAL]: PRIMARY,
  layout: {
    headerHeight: 70,
    headerHeightMobile: 70,
    headerLogoContainerWidth: 250,
    headerFeedContainer: 250,
  },
};
